// extracted by mini-css-extract-plugin
export var card = "post-card-module--card--A3zkf";
export var contentBox = "post-card-module--content-box--CMwr0";
export var date = "post-card-module--date--eMNt7";
export var header = "post-card-module--header--SDu-T";
export var imgBox = "post-card-module--img-box--VFLWm";
export var more = "post-card-module--more--6qZso";
export var ratio = "post-card-module--ratio--ddk1k";
export var smallHeader = "post-card-module--small-header--Ov5m5";
export var subheader = "post-card-module--subheader--Mjmgw";